<template>
  <header>
    <div class="container">
      <div class="row">
        <a href="https://www.tn.ru/" target="_blank" class="header__logo">
          <img src="@/assets/img/logo.svg" alt="logo">
        </a>
      </div>
      <div class="row">
        <div class="header__content">
          <div class="header__content-title">
            КАЛЬКУЛЯТОР <br>ВЕТРОВОЙ НАГРУЗКИ НА КРОВЛЮ
          </div>
          <div class="header__content-menu">
            <button class="header__content-menu--btn" @click="isShowBtns = !isShowBtns">
              <img src="@/assets/img/menu.svg" alt="menu">
            </button>
            <div class="header__content-modal" v-if="isShowBtns">
              <button @click="isShowBtns = !isShowBtns"
                      class="header__content-modal--close">
                <img src="@/assets/img/close-red.svg" alt="close">
              </button>
              <a href="https://nav.tn.ru/message/" target="_blank"
                 class="header__content-modal--error">
                <img src="@/assets/img/alert.svg" alt="!">
                <span>Нашли <br>ошибку?</span>
              </a>
              <a href="https://nav.tn.ru/calculators/embed/" target="_blank"
                 class="header__content-modal--code">
                <img src="@/assets/img/coder.svg" alt="<>">
                <span>Код <br>на сайт</span>
              </a>
            </div>
          </div>
          <div class="header__content-btns">
            <a href="https://nav.tn.ru/message/" target="_blank"
               class="header__content-btns--error">
              <img src="@/assets/img/alert.svg" alt="!">
              <span>Нашли <br>ошибку?</span>
            </a>
            <a href="https://nav.tn.ru/calculators/embed/" target="_blank"
               class="header__content-btns--code">
              <img src="@/assets/img/coder.svg" alt="<>">
              <span>Код <br>на сайт</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    pdfStart: Boolean,
  },
  components: {
  },
  data() {
    return {
      isShowBtns: false,
    };
  },
  watch: {
  },
  methods: {
  },
  computed: {
  },
  mounted() {
  },
};
</script>

<style lang="sass" scoped>
  header
    background: #fff
    z-index: 4
    position: relative
    +media((padding: (320: rem(23) 0 rem(20), 992: rem(27) 0 rem(34))))
  .header
    &__logo
      +media((padding-left: (320: rem(24), 992: 0)))
    &__content
      display: grid
      width: 100%
      +media((grid-template-columns: (320: 12fr 2fr, 992: 8fr 3fr)))
      &-title
        font-style: normal
        font-weight: bold
        color: $black
        text-align: left
        padding-top: rem(10)
        +media((font-size: (320: rem(18), 992: rem(28))))
        +media((line-height: (320: rem(28), 992: rem(34))))
        +media((padding-left: (320: rem(24), 992: 0)))
      &-menu
        +media((display: (320: block, 992: none)))
        padding-right: rem(24)
        padding-top: rem(10)
        position: relative
        &--btn
          background: none
          box-shadow: none
          border: none
          outline: none
      &-btns
        +media((display: (320: none, 992: flex)))
        padding-top: rem(10)
        position: relative
      &-modal
        padding: rem(26) rem(30) rem(26) rem(30)
        position: absolute
        top: 0
        right: rem(24)
        z-index: 2
      &-btns, &-modal
        align-items: center
        +media((flex-direction: (320: column, 992: row)))
        +media((box-shadow: (320: 0 rem(4) rem(14) rem(2) rgba(0, 0, 0, 0.16), 992: none)))
        +media((border-radius: (320: rem(4), 992: 0)))
        +media((background: (320: #fff, 992: none)))
        +media((align-items: (320: flex-start, 992: center)))
        +media((justify-content: (320: center, 992: flex-end)))
        &--close
          background: none
          box-shadow: none
          outline: none
          border: none
          padding: 0
          position: absolute
          top: 0
          right: 0
          line-height: 0
          padding: rem(8)
          img
            height: rem(10)
        &--error
          +media((padding-right: (320: 0, 992: rem(20))))
        &--error, &--code
          display: flex
          flex-direction: row
          align-items: center
          cursor: pointer
          text-decoration: none
          img
            padding-right: rem(11)
          span
            font-style: normal
            font-weight: 500
            font-size: rem(12)
            line-height: rem(15)
            color: #999999
            text-align: left
            +media((padding: (320: rem(8) 0, 992: 0)))
</style>
